import React, { useState } from 'react'
import { Editor } from '@tinymce/tinymce-react';
import t from "../../../translate";

// Import TinyMCE Core
import 'tinymce/tinymce';

// Import Theme, Icons, and Model
import 'tinymce/themes/silver'; // Default theme
import 'tinymce/icons/default'; // Default icons
//import 'tinymce/models/dom';    // DOM model

// Import Required Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';

const EditorPart = (props) => {

  return (
    <div className="editor_holder">
    <Editor
      inline
      value={props.part_content != '' ? props.part_content : ''}
      init={{
        relative_urls: false,
        remove_script_host: false,
        base_url: '/tinymce', // Base path for all TinyMCE resources
        skin_url: '/tinymce/skins/ui/oxide',
        content_css: '/tinymce/skins/content/default/content.css',
        menubar:false,
        plugins: 'link image code lists advlist',
        toolbar: [
          "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify",
          "bullist numlist outdent indent | table | fontsizeselect | link | removeformat | code"],
        setup: editor => {
          //Keep bg image dark if on focus
          editor.on('keydown', function(e){
            try {
              if(e.target.nextSibling.nextSibling.classList)
              {

                if(e.target.nextSibling.nextSibling.classList.contains('placeholder_editor')){
                  e.target.nextSibling.nextSibling.classList.add("hide")
                }
              }
            } catch(err) {} //tbv traslations
          });
          editor.on('focus', function(e){
            try {
              if(e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList)
              {
                if (e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList.contains('imageAsBg')) {
                  e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList.add("editting")
                }
              }
            }
            catch(err) {} //tbv translations...
          });
          //Remove dark bg on focus out
          editor.on('blur', function(e){
            try {
              if(e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList)
              {
                if (e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList.contains('imageAsBg')) {
                  e.target.targetElm.parentElement.parentElement.parentElement.previousSibling.classList.remove("editting")
                }
              }
            }
            catch(err) {} //tbv translations
          });
        }
        /*myCustomToolbarButton
        setup: (editor) => {
          editor.ui.registry.addButton('myCustomToolbarButton', {
            text: 'My Custom Button',
            onAction: () => props.showMediaLibrary()
          });

        }  */
      }}
      onEditorChange={(content, editor) => props.updatePart(props.index, props.update_field, (content == "<br>" ? "":content))}
      />

        {props.part_content == "" ?
          <div className="placeholder_editor">
            {t("Plaats hier uw tekst")}...
          </div>
        :''}

      </div>
  )
};

export default EditorPart;
